import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthServices } from '@app/core/services/auth.services';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-callback',
  template: `
    <div class="flex gap-8">
      <p-skeleton height="100vh" width="16vw" styleClass="mb-2" borderRadius="1px"> </p-skeleton>
      <p-skeleton height="100vh" width="86vw" styleClass="mb-2" borderRadius="1px"> </p-skeleton>
    </div>
  `,
  standalone: true,
  imports: [SkeletonModule],
})
export class CallbackComponent implements OnInit {
  constructor(private route: ActivatedRoute, private authServices: AuthServices, private router: Router) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const code = params['code'];
      if (code) {
        this.authServices.handleCallback(code);
      }
    });
  }
}
